import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/components/shared/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/components/shared/ClipboardButton/ClipboardButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/crystallize-cdn-image-loader.ts");
